import React, { useEffect, useState } from 'react';
import Container from '../Container/Container';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { get } from '../ApiServices/ApiServices';
import Loader from './Component/Loader';
function AffiliatedDetail() {
    const [singleData, setSingleData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [groupName, setGroupName] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    // const { id } = useParams();
    const { id } = location.state || {};

    useEffect(() => {
        fetchSingleGroup();
    }, [id, currentPage, itemsPerPage, searchQuery]);

    const fetchSingleGroup = async () => {
        try {
            setLoading(true);
            const api = `view-group-new/${id}?page=${currentPage}&limit=${itemsPerPage}&search=${searchQuery}`;
            const totalData = await get(api);
            setGroupName(totalData?.data?.name);
            setSingleData(totalData?.data?.users?.rows || []); // Set the state with the fetched data
            setTotalItems(totalData?.data?.users?.count || 0);
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Reset to the first page when changing items per page
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Affiliated Detail</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <div className="toggle-wrap nk-block-tools-toggle">
                                            <div className="toggle-expand-content" data-content="pageMenu">
                                                <ul className="nk-block-tools g-3">
                                                    <div className="">
                                                        <span
                                                            onClick={() => navigate(-1)}
                                                            className="btn btn-outline-light"
                                                        >
                                                            <em class="icon ni ni-arrow-left"></em> <span> Back</span>
                                                        </span>
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <div className="card-title-group mb-3">
                                        <div className="card-tools">
                                            <div className="form-control-wrap ">
                                                <div className="form-icon form-icon-right">
                                                    <em className="icon ni ni-search"></em>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search by #Acc, Company Name, or Email"
                                                    value={searchQuery}
                                                    onChange={handleSearchChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {loading ?
                                        <Loader /> // Show Loader while data is being fetched
                                        :
                                        <>
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Acct #</th>
                                                        <th scope="col">Company Name</th>
                                                        <th scope="col">Owner</th>
                                                        <th scope="col">Affiliated Store</th>
                                                        <th scope="col">Phone</th>
                                                        <th scope="col">Email</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {singleData.length > 0 ? (
                                                        singleData.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item?.account}</td>
                                                                <td>{item?.companyName}</td>
                                                                <td>{item?.firstName} {item?.lastName}</td>
                                                                <td>{groupName}</td>
                                                                <td>{item?.phone}</td>
                                                                <td>{item?.email}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="6" className="text-center">
                                                                <div className="data-not-found">
                                                                    <em className="icon ni ni-info"></em>
                                                                    <p>No data available</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            {
                                                singleData.length > 0 ? <div className="nk-block-between-md g-3 mt-3">
                                                    <div className="g">
                                                        <div className="pagination d-flex gap-2" style={{ height: "35px" }}>
                                                            <button
                                                                className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
                                                                onClick={() => handlePageChange(currentPage - 1)}
                                                                disabled={currentPage === 1}
                                                            >
                                                                Previous
                                                            </button>

                                                            {Array.from({ length: Math.ceil(totalItems / itemsPerPage) }, (_, i) => (
                                                                <button
                                                                    key={i + 1}
                                                                    className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                                                                    onClick={() => handlePageChange(i + 1)}
                                                                >
                                                                    {i + 1}
                                                                </button>
                                                            )).slice(Math.max(0, currentPage - 3), Math.min(currentPage + 2, Math.ceil(totalItems / itemsPerPage)))}

                                                            <button
                                                                className={`btn btn-sm ${currentPage === Math.ceil(totalItems / itemsPerPage) ? 'btn-disabled' : 'btn-primary'}`}
                                                                onClick={() => handlePageChange(currentPage + 1)}
                                                                disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
                                                            >
                                                                Next
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {totalItems > 20 && (
                                                        <div className="g">
                                                            <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                                                                <div>Showing</div>
                                                                <div>
                                                                    <select
                                                                        className="form-select js-select2"
                                                                        value={itemsPerPage}
                                                                        onChange={handleItemsPerPageChange}
                                                                    >
                                                                        {totalItems >= 10 && <option value="10">10</option>}
                                                                        {totalItems >= 20 && <option value="20">20</option>}
                                                                        {totalItems >= 50 && <option value="50">50</option>}
                                                                        {totalItems >= 100 && <option value="100">100</option>}
                                                                    </select>
                                                                </div>
                                                                <div>of {totalItems} items</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div> : ''
                                            }

                                        </>

                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default AffiliatedDetail;